/**
 * Media URLs from Wikidata/Ticketmaster often contain spaces or parentheses.
 * Unquoted CSS url() treats those as syntax and the portrait never paints.
 */

export function safeMediaUrl(url) {
  if (url == null) return null;
  const raw = String(url).trim();
  if (!raw) return null;
  try {
    return encodeURI(decodeURI(raw));
  } catch {
    try {
      return encodeURI(raw);
    } catch {
      return raw;
    }
  }
}

export function cssUrlValue(url) {
  const safe = safeMediaUrl(url);
  if (!safe) return undefined;
  return `url("${safe.replace(/\\/g, '\\\\').replace(/"/g, '%22')}")`;
}
